import './nextphaze/style';
import FormStructure from './nextphaze/form_structure';

export default FormStructure;